export class CodeValue {
	constructor(
		public code: string,
		public paramChar: string
	){}
}